export const ModalModes = Object.freeze({ SAVE: 'save', DOWNLOAD: 'download', PROPOSAL: 'proposal' });
